import reasons from './reasons'
import companies from './companies'
import employees from './employees'
import journeys from './journeys'
import userGroups from './userGroups'
import oncall from './oncall'
import routines from './routines'
import employers from './employers'
import supervisors from './supervisors'
import customRules from './customRules'
import approvalsRules from './approvalsRules'
import disciplineRules from './disciplineRules'
import regions from './regions'
import users from './users'
import roleGroups from './roleGroups'
import permissions from './permissions'
import activities from './activities'
import repModels from './repModels'
import reps from './reps'

export default {
  namespaced: true,
  modules: { companies, employees, reasons, journeys, oncall, userGroups, routines, employers, supervisors, customRules, approvalsRules, disciplineRules, regions, users, roleGroups, permissions, activities, repModels, reps },
  actions: {
    loadMainCommons ({ dispatch }) {
      ['employees', 'companies'].forEach(i => {
        dispatch(`${i}/fetchItems`)
      })
    }
  }
}
